import { useState, useMemo } from "react";
import { usePeriod } from "../lib/PeriodContext";
import { Filter, X, Check } from "lucide-react";

export const ProjectFilter = () => {
  const { projects, selectedProjects, setSelectedProjects } = usePeriod();
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  const filtered = useMemo(
    () => projects.filter((p) => p.project_name.toLowerCase().includes(query.toLowerCase())),
    [projects, query]
  );

  const toggle = (name) => {
    if (selectedProjects.includes(name)) {
      setSelectedProjects(selectedProjects.filter((n) => n !== name));
    } else {
      setSelectedProjects([...selectedProjects, name]);
    }
  };

  const clear = () => setSelectedProjects([]);
  const selectAll = () => setSelectedProjects(filtered.map((p) => p.project_name));

  const count = selectedProjects.length;

  return (
    <div className="relative flex items-center gap-1">
      <button
        onClick={() => setOpen(!open)}
        className={`flex items-center gap-1.5 px-2.5 py-1.5 text-xs border rounded-md transition-colors ${
          count > 0 ? "bg-vexen-sidebar text-white border-vexen-sidebar" : "bg-white border-slate-200 hover:border-slate-300"
        }`}
        data-testid="project-filter-toggle"
      >
        <Filter size={13} />
        <span className="hidden sm:inline">{count === 0 ? "All Projects" : `${count} Project${count > 1 ? "s" : ""}`}</span>
      </button>
      {count > 0 && (
        <button
          onClick={clear}
          className="text-slate-500 hover:text-slate-900 px-1 py-1"
          title="Clear filter"
          data-testid="project-filter-clear"
        >
          <X size={12} />
        </button>
      )}

      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-full mt-1 bg-white border border-slate-200 rounded-md shadow-xl z-40 w-72">
            <div className="p-2 border-b border-slate-100 flex gap-1">
              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search projects..."
                className="flex-1 px-2 py-1 border border-slate-200 rounded text-xs"
                data-testid="project-filter-search"
              />
            </div>
            <div className="flex items-center justify-between px-3 py-1.5 border-b border-slate-100 text-[10px] font-mono uppercase tracking-wider">
              <button onClick={clear} className="text-slate-500 hover:text-slate-900" data-testid="project-filter-clear-all">Clear</button>
              <button onClick={selectAll} className="text-slate-500 hover:text-slate-900" data-testid="project-filter-select-all">Select all</button>
            </div>
            <div className="max-h-80 overflow-y-auto scroll-thin">
              {filtered.map((p) => {
                const isSel = selectedProjects.includes(p.project_name);
                return (
                  <button
                    key={p.project_name}
                    onClick={() => toggle(p.project_name)}
                    className="w-full flex items-center gap-2 px-3 py-1.5 hover:bg-slate-50 text-left"
                    data-testid={`project-filter-opt-${p.project_name.replace(/\s+/g, "-")}`}
                  >
                    <div className={`w-3.5 h-3.5 border rounded flex items-center justify-center ${isSel ? "bg-vexen-sidebar border-vexen-sidebar" : "border-slate-300"}`}>
                      {isSel && <Check size={10} className="text-white" />}
                    </div>
                    <span className="text-xs flex-1 truncate">{p.project_name}</span>
                    <span className="text-[9px] text-slate-400 font-mono uppercase">{p.city}</span>
                  </button>
                );
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
